module.exports = __webpack_public_path__ + "img/23.c90580b8.png";